import { END, EventChannel, eventChannel } from 'redux-saga';
import { NotUndefined } from '@redux-saga/types';

const createBroadcastEventChannel = <T extends NotUndefined>(
  broadcastChannel: BroadcastChannel | undefined
): EventChannel<T> => {
  return eventChannel((emitter) => {
    const eventListener = (event: MessageEvent<T>): void => {
      emitter(event.data);
    };

    if (broadcastChannel === undefined) {
      emitter(END);
    } else {
      broadcastChannel.addEventListener('message', eventListener);
    }

    return () => {
      broadcastChannel?.removeEventListener('message', eventListener);
    };
  });
};

export default createBroadcastEventChannel;
